export { default as Img200 } from './processed/200/Dredd_Foxtel.jpg';
export { default as Img400 } from './processed/400/Dredd_Foxtel.jpg';
export { default as Imgthumb } from './processed/thumb/Dredd_Foxtel.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Dredd_Foxtel.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Dredd_Foxtel.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      212,
      23,
      30
    ],
    "_population": 2156,
    "_hsl": [
      0.9938271604938271,
      0.8042553191489361,
      0.4607843137254902
    ]
  },
  "LightVibrant": {
    "_rgb": [
      244,
      219,
      151
    ],
    "_population": 615,
    "_hsl": [
      0.12186379928315409,
      0.8086956521739134,
      0.7745098039215687
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      142,
      26,
      30
    ],
    "_population": 393,
    "_hsl": [
      0.9942528735632185,
      0.6904761904761906,
      0.32941176470588235
    ]
  },
  "Muted": {
    "_rgb": [
      144,
      93,
      81
    ],
    "_population": 2066,
    "_hsl": [
      0.031746031746031744,
      0.28,
      0.4411764705882353
    ]
  },
  "LightMuted": {
    "_rgb": [
      209,
      192,
      167
    ],
    "_population": 330,
    "_hsl": [
      0.0992063492063492,
      0.31343283582089543,
      0.7372549019607844
    ]
  },
  "DarkMuted": {
    "_rgb": [
      74,
      44,
      46
    ],
    "_population": 1302,
    "_hsl": [
      0.9888888888888889,
      0.25423728813559326,
      0.23137254901960785
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Dredd_Foxtel.js